import React, { useContext, useMemo } from 'react';

import '../styles/Homepage.css';
import { bool } from 'prop-types';
import Seo from './Seo';
import AppContext from '../components/context/AppContext';
import AboutUs from './AboutUs';
import HeroSlideshow from './HeroSlideshow';
import HomeArticles from './HomeArticles';
import { Link } from 'react-router-dom';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import HomeFeaturesList from './HomeFeaturesList';
import HomeCategories from './HomeCategories';
import FilteredProductList from './FilteredProductList';

// Homepage component
// Rendered at the root path
const Homepage = ({ isMobile }) => {
    const { appContext } = useContext(AppContext);
    const articlePath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.ARTICLE_PATH });
    const appConfig = appContext.config.themeConfig;
    const slideShowItems = useMemo(() => [...appConfig.heroSection.images.map((section) => ({
        backgroundUrl: section.backgroundUrl,
    }))], [appConfig]);

    return (<>
        <Seo
            seoTitle={appConfig.seoTitle ?? appContext.config.storeName}
            seoType={'website'}
            seoDescription={appConfig.seoDescription}
            canonicalUrl={process.env.APP_URL}
        />
        <div
            className={'section'}
        >
            <HomeFeaturesList />
            <HeroSlideshow
                isMobile={isMobile}
                items={slideShowItems}
            />
            <HomeCategories/>
            <FilteredProductList
                isBestSelling={true}
                isMobile={isMobile}
                title={'Best Sellers'} />
            <HomeArticles
                isMobile={isMobile}
            />
            {isMobile ? (
                <Link
                    to={`${articlePath[0].fullPath}`}
                    className={'home--blog-link'}
                >
                    Visit LiftPartsWarehouse Blogs
                </Link>
            ): null}
            <AboutUs
                descriptions={appConfig.aboutUs.descriptions}
            />
        </div>
    </>);
};

Homepage.propTypes = {
    isMobile: bool,
};

export default Homepage;